var map = {
	"./02_hero_desktop.jpg": 363,
	"./02_hero_mobile.jpg": 364,
	"./02_hero_tablet.jpg": 365,
	"./04_hero_desktop.jpg": 366,
	"./04_hero_mobile.jpg": 367,
	"./04_hero_tablet.jpg": 368,
	"./06_hero_desktop.jpg": 369,
	"./06_hero_mobile.jpg": 370,
	"./06_hero_tablet.jpg": 371,
	"./07_hero_desktop.jpg": 372,
	"./07_hero_mobile.jpg": 373,
	"./07_hero_tablet.jpg": 374,
	"./08_hero_desktop.jpg": 375,
	"./08_hero_mobile.jpg": 376,
	"./08_hero_tablet.jpg": 377,
	"./10_hero_desktop.jpg": 378,
	"./10_hero_mobile.jpg": 379,
	"./10_hero_tablet.jpg": 380,
	"./11b_hero_desktop.jpg": 381,
	"./11b_hero_mobile.jpg": 382,
	"./11b_hero_tablet.jpg": 383,
	"./12b_hero_desktop.jpg": 384,
	"./12b_hero_mobile.jpg": 385,
	"./12b_hero_tablet.jpg": 386,
	"./Corteva_Do_More_with_Less.jpg": 387,
	"./Corteva_From_Data_to_Decision.jpg": 388,
	"./Tanzania-Queen-and-Son-small.jpg": 389,
	"./Thailand.jpg": 390,
	"./artOfPrecision-desktop.jpg": 391,
	"./brazil_old_pastures.jpg": 392,
	"./cracking-the-code.jpg": 393,
	"./farmingWithNoRain-desktop.jpg": 394,
	"./foodByPrescription-desktop.jpg": 395,
	"./howTheWorldGrow-desktop.jpg": 396,
	"./seeds-of-change-desktop.jpg": 397,
	"./silicon-farm-thumbnail.jpg": 398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;